import React from 'react'
import { Checkbox } from 'hljd'
import style from './style.module.less'
export default props => {
  const { cover_path, title, id, isServiceRelated } = props.data
  const { mode, selectcase, preSetMeal, disabledMealList } = props.store
  const checked = preSetMeal.some(el => el.data.id == id)
  const disabled = mode === 'replace' && disabledMealList.some(el => el === id)
  return (
    <div
      className={style.case}
      onClick={() => selectcase(!checked, id, isServiceRelated == 1)}
    >
      <img
        className={style.caseCoverPath}
        src={cover_path + '?imageView2/1/w/136/h/96'}
      />
      <p className={style.caseName}>{title}</p>
      <Checkbox
        className={style.checkBox}
        checked={checked}
        disabled={disabled}
      />
    </div>
  )
}
